import React, { forwardRef } from "react";
interface ButtonProps {
  text: string;
  type: string;
  customClass?: string;
  isDisabled?: boolean;
  onClick: () => void;
  testId?: string;
}

const TYPE = {
  primary: "button-primary",
  secondary: "button-secondary",
  tertiary: "button-tertiary",
  alert: "button-alert",
  disable: "button-disable",
};

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ text, type, customClass = "", isDisabled, onClick, testId, children }, ref) => {
    return (
      <button
        className={`${customClass} ${isDisabled ? TYPE.disable : TYPE[type]}`}
        disabled={isDisabled}
        onClick={onClick}
        data-testid={testId}
        ref={ref}
      >
        {text || children}
      </button>
    );
  },
);

export default Button;
